module.exports = __webpack_public_path__ + "2b64211512445cdf2dba6b40a89119f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/reading.png
// module id = 1673
// module chunks = 0